module.exports = __webpack_public_path__ + "static/img/5138_phase_function_Paper_PointsHejduk_Prediction.897dcad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5138_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jZCu
// module chunks = 0